import { MUIDataTableMeta } from 'mui-datatables';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash } from '@fortawesome/free-solid-svg-icons';
import CustomTable from '../../common/components/CustomTable/CustomTable';
import ISource from '../../interfaces/Source';

const SourcesColumns = (props: {
    onEditClick: (tableMeta: MUIDataTableMeta<ISource>) => void,
    onDeleteClick: (tableMeta: MUIDataTableMeta<ISource>) => void,
    sources: ISource[]
}) => {
    const { sources, onEditClick, onDeleteClick } = props

    const sourcesColumns = [
        {
            name: "id",
            label: "Id",
            options: {
                display: false
            }
        },
        {
            name: "name",
            label: "Nome",
        },
        {
            name: "code",
            label: "Codice",
        },
        {
            name: "azioni",
            label: "Azioni",
            options: {
                customBodyRender: (value: any, tableMeta: MUIDataTableMeta<ISource>, updateValue: any) => (
                    <>
                        <Button className='btn btn-primary rounded-circle me-1 shadow-sm' onClick={() => onEditClick(tableMeta)}><FontAwesomeIcon icon={faPen} /></Button>
                        <Button className='btn btn-danger rounded-circle shadow-sm' onClick={() => onDeleteClick(tableMeta)}><FontAwesomeIcon icon={faTrash} /></Button>
                    </>
                )
            }
        },
    ]

    return (
        <CustomTable
            title={"Elenco di tutte le sorgenti disponibili"}
            data={sources}
            columns={sourcesColumns}
        />
    )
}

export default SourcesColumns;